<template>
    <div>
        <SpeakerTable/>
        <!-- <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    color="#FBBD21"
                    dark
                    fab
                    fixed
                    right
                    bottom
                    @click="newSpeaker()"
                >
                    <v-icon color="white">{{ icons.mdiPlus }}</v-icon>
                </v-btn>
            </template>
            <span>New Speaker</span>
        </v-tooltip> -->
        <v-snackbar
            v-model="snackbar.show"
            top
            right
            :timeout="4000"
            :color="snackbar.color"
        >
            {{ snackbar.text }}
        </v-snackbar>
    </div>
</template>
<script>
import SpeakerTable from '@/components/molecules/SpeakerTable.vue'
import { mdiPlus } from "@mdi/js"
import { mapGetters } from 'vuex'

export default {
    name: "Speaker",
    data: () => ({
        icons: {
            mdiPlus,
        }
    }),
    computed: {
        ...mapGetters(["snackbar"])
    },
    components: {
        SpeakerTable,
    },
    methods: {
        newSpeaker() {
            this.$router.push("/dashboard/speaker/new/");
        }
    }
}
</script>
